// All three backend hosts are supplied at build time via REACT_APP_* env
// vars (see .env.example) — set as GitHub Environment variables per branch
// (staging -> azure-stag, production -> azure-prod) so each deployment
// points at its own backend. Deliberately no hardcoded fallback here: a
// missing env var should surface as an obvious broken request, not a
// silent fall-through to the wrong environment's API.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_BASE_PATH = `${API_BASE_URL}/api/v1/`;

export const RAPSAP_OPS_BASE_URL = process.env.REACT_APP_RAPSAP_OPS_BASE_URL;

// Staff Ops / Checklist API (a third, separate backend behind its own
// gateway — see APIs_List.md's sibling doc, the "Staff Ops API" reference).
// Note: this is the host only — src/helpers/checklistApi.js already appends
// `/rapsap-operations/...` to every path, so it must NOT be included here too.
export const CHECKLIST_API_BASE_URL = process.env.REACT_APP_OPERATIONS_API_BASE_URL;

export default {
  API_BASE_URL,
  API_BASE_PATH,
  RAPSAP_OPS_BASE_URL,
  CHECKLIST_API_BASE_URL,
};
